'use client';

import { StandardAsset } from '$components/Asset';
import { LayoutContext } from '$root/src/context';
import cn from 'classnames';
import Link from 'next/link';
import { HTMLAttributes, useContext, useEffect, useRef, useState } from 'react';

import FadeInSection from '../FadeInSection/FadeInSection';
import { Tag } from '../Tag/index';
import { IListItem } from './';

export function ListItem(props: IListItem & HTMLAttributes<HTMLElement>) {
  const {
    newTab,
    className,
    assets,
    assetOverlay,
    organizationLogo,
    itemIndex = 0,
    url,
    tag,
    heading,
    subHeading,
  } = props;

  const useLayoutStore = useContext(LayoutContext);
  const setTransition = useLayoutStore((state) => state.setTransition);

  const contentElement = useRef(null);
  const [height, setHeight] = useState(0);

  useEffect(() => {
    const r = () => {
      setHeight(contentElement.current.offsetWidth * 1.25);
    };
    window.addEventListener('resize', r);
    r();
    return () => {
      window.removeEventListener('resize', r);
    };
  }, []);
  const href = url;
  const linkProps = {
    ...(newTab ? { target: '_blank', rel: 'noindex nofollow' } : {}),
  };

  return (
    <FadeInSection delay={itemIndex * 200}>
      <Link
        href={href}
        className={'w-full block'}
        onClick={() => {
          if (!newTab) {
            setTransition(() => true);
          }
        }}
        {...linkProps}
      >
        <section
          className={cn(className, 'text-gray-600 body-font overflow-hidden')}
        >
          <div className={cn('flex')} style={{ height: height }}>
            <div
              ref={contentElement}
              style={{
                height: height,
              }}
              className={cn(
                'dark px-8 w-full py-8  gap-3 justify-end items-left aspect-square bg-no-repeat bg-center bg-cover flex flex-wrap flex-col rounded-[2.5rem] overflow-hidden relative',
              )}
            >
              <StandardAsset
                assets={assets}
                overlay={assetOverlay}
                sizes="(min-width: 1024px) 50vw, 100vw"
                className={cn('absolute top-0 z-0 left-0')}
              />
              <Tag
                className={cn('relative z-10')}
                status={'inactive'}
                label={tag}
              />
              {organizationLogo && (
                // Updating the data-categories to be essential as termly currently blocks it without this being set
                <img
                  alt={organizationLogo.description || 'logo'}
                  className={cn(
                    'relative z-10 max-w-[60px] max-h-[60px] object-contain',
                  )}
                  data-categories="essential"
                  loading="lazy"
                  src={organizationLogo.url}
                />
              )}
              <h3
                className={cn(
                  'style-heading-xxs font-medium text-white z-10 relative',
                )}
              >
                {heading}
              </h3>
              {subHeading && (
                <h4
                  className={cn('style-heading-xxxs text-white z-10 relative')}
                >
                  {subHeading}
                </h4>
              )}
            </div>
          </div>
        </section>
      </Link>
    </FadeInSection>
  );
}
